var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"160","width":"114.5","height":"352","key":0}),React.createElement("path",{"d":"M426.4 164.1c-1.2-0.4-2.4-0.8-3.6-1.2 -1.5-0.4-3.1-0.6-4.6-0.9 -6.1-1.2-12.7-2.1-20.5-2.1 -66.8 0-109.1 48.5-123 67.3V160H160v352h114.5V320c0 0 86.5-120.5 123-32 0 79 0 224 0 224H512V274.5C512 221.3 475.6 177 426.4 164.1z","className":"a","key":1}),React.createElement("circle",{"cx":"56","cy":"56","r":"56","key":2})]);
}

Linkedin.defaultProps = {"viewBox":"0 0 512 512","width":"512","height":"512"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
